import { toTitleCase } from '../../../libs/strings/strings';

export const CUSTOM_REVIEW_SOURCE = 'custom';

export const WEBSITE_REVIEW_SOURCE = 'website';

export const MAX_STAR_RATING = 5;

export const REVIEW_RESPONSE_STATUS_CREATED = 'CREATED';
export const REVIEW_RESPONSE_STATUS_PENDING = 'PENDING';
export const REVIEW_RESPONSE_STATUS_SUBMITTED = 'SUBMITTED';
export const REVIEW_RESPONSE_STATUS_FAILED = 'FAILED';

const REVIEW_RESPONSE_STATUS_TEXT_MAP = {
  [REVIEW_RESPONSE_STATUS_CREATED]: toTitleCase(REVIEW_RESPONSE_STATUS_CREATED),
  [REVIEW_RESPONSE_STATUS_PENDING]: toTitleCase(REVIEW_RESPONSE_STATUS_PENDING),
  [REVIEW_RESPONSE_STATUS_SUBMITTED]: toTitleCase(REVIEW_RESPONSE_STATUS_SUBMITTED),
  [REVIEW_RESPONSE_STATUS_FAILED]: toTitleCase(REVIEW_RESPONSE_STATUS_FAILED),
};

export const getReviewResponseStatusText = (status) => {
  return REVIEW_RESPONSE_STATUS_TEXT_MAP[status];
};

const ALL_REVIEW_RESPONSE_STATUS = { key: '', value: '', text: 'All Statuses' };
export const REVIEW_RESPONSE_STATUS_OPTIONS = [
  ALL_REVIEW_RESPONSE_STATUS,
  ...[
    REVIEW_RESPONSE_STATUS_CREATED,
    REVIEW_RESPONSE_STATUS_PENDING,
    REVIEW_RESPONSE_STATUS_SUBMITTED,
    REVIEW_RESPONSE_STATUS_FAILED,
  ].map((status) => ({
    key: status,
    text: getReviewResponseStatusText(status),
    value: status,
  })),
];
